import styled from 'styled-components';

export const SideMenuSeparator = styled.div`
	width: 60%;
	height: 1px;
	background-color: ${({ theme }) => theme.colors.borderDefault};
	padding: 0;
	margin: 10px auto;
	list-style-type: none;
`;
